<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import PotentialScoringV2 from '#/detailsReport/version2/PotentialScoringV2'
const { lead } = useDetailsReport()
</script>

<template lang="pug">
.leadAnalysisContainer
  .analysis--title Die Analyse der Liegenschaft:
  potential-scoring-v2
</template>

<style scoped lang="sass">
.leadAnalysisContainer
  width: 100%
  margin-top: 30px
  .mobileTitleTopPadding
    @media screen and (max-width: 1023px)
      margin-top: 20px
  .analysis--title
    @media screen and (min-width: 1024px)
      margin-bottom: 20px
      font-weight: bold
      font-size: 30px
      line-height: 130%
      color: #22223C
    @media screen and (max-width: 1023px)
      margin-bottom: 15px
      font-weight: 700
      font-size: 20px
      line-height: 200%
      color: #2F3849
</style>
